import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { parseJwt } from "../utils/token.util.ts";

const DOMINIO_PERMITIDO = "@controlsis.com.br";

// Gate de conveniência de UI - a autorização de verdade é sempre re-checada
// no backend (AdminAccessInterceptor), que também exige allowlist.
const AdminRoute = ({ children }: { children: ReactNode }) => {
  const token = localStorage.getItem("token");
  const payload = parseJwt(token);
  const email: string | undefined = payload?.sub;

  const autorizado = !!email && email.toLowerCase().endsWith(DOMINIO_PERMITIDO);

  if (!autorizado) return <Navigate to="/cirurgias" replace />;

  return children;
};

export default AdminRoute;
